import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Cost } from '../models/cost.model';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  private print = new BehaviorSubject([]);
  print$ = this.print.asObservable();

  constructor() { }

  addCosts(costs: Cost[]) {
    this.print.next(costs);
  }
}
